/** Brand tokens — aligned with Yhataw-2.0 (#841C39 primary) */
export const colors = {
  white: "#FFFFFF",
  black: "#3D001F",
  red: "#FF1717",
  lightGray: "#757D85",
  grayText: "#DCDDE5",
  grayText2: "#858C94",
  primaryBlue: "#841C39",
  primaryBlue2: "#A02448",
  bgBlue: "#3D001F",
  primaryGreen: "#FFFFFF",
  primaryBorder: "#E6E1DC",
  secondaryBorder: "#D4B8C0",
  otherBorder: "#EFEFEF",
  otherBorder2: "#F5E8EC",
  secondaryBlue: "#F9F0F4",
  secondaryText: "#4D5369",
  bgColor: "#FFFFFF",
  bgColor2: "#FFFFFF",
  bgColor3: "#FFFFFF",
  bgColor4: "#FFFFFF",
  textWhite: "#F0F1F5",
} as const;

export const fonts = {
  regular: "HelveticaNeueRegular, Inter_Regular, sans-serif",
  bold: "HelveticaNeueBold, Inter_Medium, sans-serif",
} as const;

export const radii = {
  sm: "4px",
  md: "8px",
  lg: "12px",
  xl: "24px",
} as const;

export const shadows = {
  sm: "0 1px 3px rgba(61, 0, 31, 0.08)",
  md: "0 4px 20px rgba(61, 0, 31, 0.12)",
  lg: "0 8px 32px rgba(132, 28, 57, 0.16)",
} as const;
